export default __webpack_public_path__ + "static/media/single-project-page-04-img07.b633b4e6.jpg";